import Api from '@services/API';
import getStandardInstance from '@utils/getStandardInstance';

const standard = getStandardInstance();

/**
 * @typedef {XGrowWithdrawalsService}
 */
export default class XGrowWithdrawalsService extends Api {
  /**
   * @type {String}
   */
  static base = '/api'
  static resource = '/integration/xgrow/withdrawal'

  constructor(resource = XGrowWithdrawalsService.resource, options = {}, http = null) {
    super(XGrowWithdrawalsService.normalize(XGrowWithdrawalsService.base, resource), options, http)
  }

  static build() {
    return new this()
  }

  search(params) {
    const queryString = new URLSearchParams(params).toString();
    return this.get(`?${queryString}`);
  }

  groups(queryString) {
    standard.defaults.responseType = 'json'
    return this.get(`/groups?${queryString}`);
  }

  getAnalysis(withdrawalId) {
    standard.defaults.responseType = 'json';
    return this.get(`/${withdrawalId}/analysis`);
  }

  getSales(withdrawalId, params = {}) {
    standard.defaults.responseType = 'json';
    const queryString = new URLSearchParams(params).toString();
    return this.get(`/${withdrawalId}/sales${queryString ? `?${queryString}` : ''}`);
  }

  updateStatus(withdrawalId, data) {
    standard.defaults.responseType = 'json';
    return this.put(`/${withdrawalId}`, data);
  }

  blob(record) {
    standard.defaults.responseType = 'blob';
    return this.post('/export', record);
  }

  checkStatus(data) {
    standard.defaults.responseType = 'json';
    return this.post('/check-status', data);
  }

  getGroupItems(queryString) {
    standard.defaults.responseType = 'json'
    return this.get(`/group?${queryString}`);
  }

  getGroupWithdrawals(queryString) {
    standard.defaults.responseType = 'json'
    return this.get(`?${queryString}`);
  }

  getGroupPaginated(payload) {
    standard.defaults.responseType = 'json'
    return this.post('/groups/items/paginated', payload);
  }

  getSalesWithFilters(withdrawalId, params) {
    const queryString = new URLSearchParams(params).toString();
    return this.get(`/${withdrawalId}/sales?${queryString}`);
  }

  getSellerHistory(sellerId, params = {}) {
    standard.defaults.responseType = 'json';
    const queryString = new URLSearchParams(params).toString();
    return this.get(`/seller/${sellerId}${queryString ? `?${queryString}` : ''}`);
  }
}